import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  history: true,
  routes: [
    {
      path: '/about-us',
      component: view('about-us'),
      children: [
        { path: '/en/about-us' },
        { path: '/nl/over-ons' }
      ]
    },
    {
      path: '/services',
      component: view('services'),
      children: [
        { path: '/en/services' },
        { path: '/nl/diensten' }
      ]
    },
    {
      path: '/advice-and-support',
      component: view('advice-and-support'),
      children: [
        { path: '/en/advice-and-support' },
        { path: '/nl/advies-en-ondersteuning' }
      ]
    },
    {
      path: '/contact',
      component: view('contact'),
      children: [
        { path: '/en/contact' },
        { path: '/nl/contact' }
      ]
    },
    {
      path: '/',
      component: view('home'),
      children: [
        { path: '/en' },
        { path: '/nl' }
      ]
    }
  ]
})

/**
 * Asynchronously load pages (Webpack Lazy loading compatible)
 * @param  {string}   name     the filename (basename) of the page to load.
 */
function view (name) {
  return function (resolve) {
    require(['../pages/page/' + name + '/' + name + '.vue'], resolve)
  }
}



// WEBPACK FOOTER //
// ./src/router/index.js